import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import event from '~helpers/mixpanel';
import CounterOffer from '~components/counter-offer';

export default class AcceptModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    if (this.props.isAutoOpen) {
      this.setState({ visible: true });
    }
  }

  acceptModalContent = () => {
    const { t, record } = this.props;

    return (
      <>
        <span>{t('landlord.payment.long_tail.accept_booking.modal.desc')}</span>
        <CounterOffer property={record} t={t} />
      </>
    );
  };

  handleShowAcceptModal = e => {
    if (this.props.history.location?.pathname === '/board') {
      event('Clicked Pending Information Btn', { 'Clicked Position': 'Accept' });
    }
    if (this.props.history.location.pathname?.includes('/detail')) {
      this.props?.handleClickActionBtnTrack?.('Accept');
    }
    if (this.props.history.location?.pathname === '/booking/list') {
      event('Clicked Action Btn in Booking List Page', { 'Clicked Position': 'Accept' });
    }

    this.setState({
      visible: !this.state.visible,
    });
  };
  cancelModal = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };
  render() {
    const { type, id, t, confirmOrder, confirmLoading } = this.props;
    const { visible } = this.state;
    return (
      <div className="accept-modal">
        <Choose>
          <When condition={type === 'list'}>
            <button className="accept-modal__btn" onClick={this.handleShowAcceptModal}>
              {t('landlord.long_tail.booking.action.accept')}
            </button>
          </When>
          <Otherwise>
            <Button onClick={this.handleShowAcceptModal} className="accept-modal__btn--detail">
              <CheckOutlined />
              {t('landlord.long_tail.booking_details.btn.accept')}
            </Button>
          </Otherwise>
        </Choose>
        <Modal
          title={t('landlord.payment.long_tail.accept_booking.modal.title')}
          width={812}
          visible={visible}
          okText={t('landlord.payment.long_tail.button.accept')}
          okButtonProps={{
            loading: confirmLoading,
            disabled: confirmLoading,
          }}
          onOk={() => {
            confirmOrder(id);
            this.handleShowAcceptModal();
          }}
          cancelText={t('landlord.payment.long_tail.button.cancel')}
          onCancel={this.cancelModal}
          wrapClassName="accept-modal__wrapper"
        >
          {this.acceptModalContent()}
        </Modal>
      </div>
    );
  }
}

AcceptModal.propTypes = {
  t: PropTypes.func,
  id: PropTypes.string,
  type: PropTypes.string,
  confirmOrder: PropTypes.func,
  isAutoOpen: PropTypes.bool,
  record: PropTypes.object,
  confirmLoading: PropTypes.bool,
  handleClickActionBtnTrack: PropTypes.func,
  fromPage: PropTypes.string,
};

AcceptModal.defaultProps = {
  t: () => {},
  id: '',
  type: '',
  confirmOrder: () => {},
  isAutoOpen: false,
  record: {},
  confirmLoading: false,
};
